import type { TBank } from "./types";
import { createPathParamCRUD } from "@/api/shared/crud";
import { createService } from "@/api/shared/service";

export * from "./types";

const SLUG = "practice/bank";

export default createService(SLUG, {
  ...createPathParamCRUD<TBank>(SLUG),

  // async get(id: string): Promise<TBank> {
  //   const response = await HTTP.get<TBank>(`${this.slug}/${id}/`);
  //   return response.data;
  // },
  // async getAll(): Promise<TBank[]> {
  //   const response = await HTTP.get<TBank[]>(`${this.slug}/`);
  //   return response.data;
  // },
  // async create(data: TBank): Promise<TBank> {
  //   const response = await HTTP.post<TBank>(`${this.slug}/`, data);
  //   return response.data;
  // },
  // async update(id: string, data: TBank): Promise<TBank> {
  //   const response = await HTTP.patch<TBank>(`${this.slug}/${id}/`, data);
  //   return response.data;
  // },
});
